import { hgNumber, HgSupportedLanguage } from '@smg-real-estate/domus';
import isNil from 'lodash.isnil';

import { PropertyType } from '@/models/iazi/common/enums';
import { type PriceValue } from '@/models/iazi/common/priceValueType';
import { type PriceValueResponse } from '@/models/iazi/queries/getPriceValueResponse';
import { dateFilter } from '@/utils/functions';

interface MedianPriceDataItem {
  price: string | null;
  range: {
    min: string | null;
    max: string | null;
  };
  date: string | null;
}

export type MedianPriceData = {
  [key in PropertyType]: MedianPriceDataItem;
};

const numberFormatter = (
  value: number | null | undefined,
  rounded: boolean,
  locale: HgSupportedLanguage,
): string => {
  if (isNil(value)) {
    return '';
  } else {
    const num = rounded ? Math.round(value / 100) * 100 : value;
    return hgNumber(num, locale);
  }
};

const getPropertyData = (
  propertyData: Array<PriceValue> | null | undefined,
  rounded: boolean,
  locale: HgSupportedLanguage,
): MedianPriceDataItem => {
  return {
    price: numberFormatter(propertyData?.[0]?.priceValueMedian, rounded, locale),
    range: {
      min: numberFormatter(propertyData?.[0]?.priceRangeMin, rounded, locale),
      max: numberFormatter(propertyData?.[0]?.priceRangeMax, rounded, locale),
    },
    date: dateFilter(propertyData?.[0]?.priceDate ?? null),
  };
};

const adaptData = (
  data: PriceValueResponse,
  rounded = false,
  locale: HgSupportedLanguage = HgSupportedLanguage.DE,
): MedianPriceData => {
  return {
    [PropertyType.Apartment]: getPropertyData(
      data?.results?.[PropertyType.Apartment],
      rounded,
      locale,
    ),
    [PropertyType.House]: getPropertyData(data?.results?.[PropertyType.House], rounded, locale),
  };
};
export default adaptData;
